import { toast } from 'sonner';

interface ErrorHandlerOptions {
  showToast?: boolean;
  fallbackMessage?: string;
}

export const handleError = (
  error: unknown,
  options: ErrorHandlerOptions = {}
): string => {
  const { showToast = true, fallbackMessage = 'Ocorreu um erro. Tente novamente.' } = options;

  // Generic user-friendly message
  const userMessage = fallbackMessage;

  // Log detailed error server-side only (in production, send to monitoring service)
  if (process.env.NODE_ENV === 'development') {
    console.error('Detailed error:', error);
  }

  if (showToast) {
    toast.error(userMessage);
  }

  return userMessage;
};

export const handleAuthError = (error: unknown): string => {
  return handleError(error, {
    fallbackMessage: 'Erro de autenticação. Por favor, faça login novamente.'
  });
};

export const handleDatabaseError = (error: unknown): string => {
  return handleError(error, {
    fallbackMessage: 'Erro ao salvar dados. Tente novamente.'
  });
};